import { ScrollView } from 'react-native'
import Typography from '@ca/ui/typography'
import { PanelBox } from './PanelBox'
import { Row } from './Row'
import { fmt, fmtVec } from './utils'
import { useLiveFaceData } from './faceDataStore'

export function LiveTab() {
  const data = useLiveFaceData()
  return (
    <ScrollView
      className="flex-1"
      contentContainerClassName="flex-grow px-4 py-3 pb-12"
    >
      <PanelBox className="flex-1">
        {data == null ? (
          <Typography variant="XS" className="text-black/40">
            Waiting for face…
          </Typography>
        ) : (
          <>
            <Row label="Detected" value={data.detected ? '● YES' : '○ NO'} />
            <Row label="Tracking" value={data.trackingMode} />
            <Row label="Confidence" value={fmt(data.confidence, 2)} />
            <Row label="Eye open L" value={fmt(data.eyeOpenness.left, 2)} />
            <Row label="Eye open R" value={fmt(data.eyeOpenness.right, 2)} />
            <Row label="PD" value={`${fmt(data.pd, 2)} mm`} />
            <Row label="Left PD" value={`${fmt(data.leftPd, 2)} mm`} />
            <Row label="Right PD" value={`${fmt(data.rightPd, 2)} mm`} />
            <Row
              label="L+R sum"
              value={`${fmt(data.leftPd + data.rightPd, 2)} mm`}
            />
            {data.pupilDebug && (
              <>
                <Row label="Pupil status" value={data.pupilDebug.status} />
                {data.pupilDebug.mapping && (
                  <Row label="Pupil mapping" value={data.pupilDebug.mapping} />
                )}
                <Row
                  label="Pupil faces"
                  value={`${data.pupilDebug.faceCount} / candidates ${data.pupilDebug.candidateCount}`}
                />
                <Row
                  label="Pupil accepted"
                  value={data.pupilDebug.accepted ? 'YES' : 'NO'}
                />
                {data.pupilDebug.leftShiftPx != null && (
                  <Row
                    label="Pupil shift"
                    value={`L ${fmt(data.pupilDebug.leftShiftPx, 1)}px  R ${fmt(
                      data.pupilDebug.rightShiftPx ?? 0,
                      1
                    )}px`}
                  />
                )}
                {data.pupilDebug.pdDeltaMm != null && (
                  <Row
                    label="Pupil PD delta"
                    value={`${fmt(data.pupilDebug.pdDeltaMm, 2)} mm`}
                  />
                )}
              </>
            )}
            <Row label="Rotation X" value={`${fmt(data.rotationX)}°`} />
            <Row label="Rotation Y" value={`${fmt(data.rotationY)}°`} />
            <Row label="Distance" value={`${fmt(data.distanceCm)} cm`} />
            <Row label="Left eye" value={fmtVec(data.leftEye)} />
            <Row label="Right eye" value={fmtVec(data.rightEye)} />
            <Row label="L cornea" value={fmtVec(data.cornea.left)} />
            <Row label="R cornea" value={fmtVec(data.cornea.right)} />
            {data.sh && (
              <>
                <Row label="SH left" value={`${fmt(data.sh.left, 2)} mm`} />
                <Row label="SH right" value={`${fmt(data.sh.right, 2)} mm`} />
              </>
            )}
            {data.shDebug && (
              <>
                <Row
                  label="SH confidence"
                  value={fmt(data.shDebug.confidence, 2)}
                />
                <Row
                  label="SH contour"
                  value={data.shDebug.selectedContourType}
                />
                {data.shDebug.rejectionReason && (
                  <Row
                    label="SH rejection"
                    value={data.shDebug.rejectionReason}
                  />
                )}
                {data.shDebug.measurementRejectionReason && (
                  <Row
                    label="SH measure reject"
                    value={data.shDebug.measurementRejectionReason}
                  />
                )}
                <Row
                  label="SH candidates"
                  value={`${data.shDebug.acceptedCandidateCount} accepted / ${data.shDebug.otherContourCount} other`}
                />
                <Row
                  label="Bright rejected"
                  value={String(data.shDebug.rejectedBrightContourCount)}
                />
                {data.shDebug.left && (
                  <Row
                    label="SH left candidate"
                    value={`C ${fmt(data.shDebug.left.confidence, 2)} Luma ${
                      data.shDebug.left.sampledLuma == null
                        ? '-'
                        : fmt(data.shDebug.left.sampledLuma, 0)
                    }${data.shDebug.left.usedArcFit ? ' Arc' : ''}`}
                  />
                )}
                {data.shDebug.right && (
                  <Row
                    label="SH right candidate"
                    value={`C ${fmt(data.shDebug.right.confidence, 2)} Luma ${
                      data.shDebug.right.sampledLuma == null
                        ? '-'
                        : fmt(data.shDebug.right.sampledLuma, 0)
                    }${data.shDebug.right.usedArcFit ? ' Arc' : ''}`}
                  />
                )}
              </>
            )}
          </>
        )}
      </PanelBox>
    </ScrollView>
  )
}
